import React, { useState } from "react"
import AsyncSelect from "react-select/lib/Async"
import PropTypes from "prop-types"
import { searchDestinationsAndHotel } from "../../helpers/searchHelper"

const SearchDestination = ({ searchByHandler }) => {
  const [initialSearchResults, setInitialSearchResults] = useState([])

  let searchTimeout = undefined
  const promiseOptions = (inputValue) => {
    if (inputValue === "") {
      if (initialSearchResults.length > 0) {
        return initialSearchResults
      } else {
        return searchDestinationsAndHotel(inputValue).then((response) => {
          if ("data" in response) {
            setInitialSearchResults(response.data.results)
            return response.data.results
          } else {
            return initialSearchResults
          }
        })
      }
    }

    if (typeof searchTimeout === "number") {
      window.clearTimeout(searchTimeout)
    }

    return new Promise((resolve) => {
      searchTimeout = window.setTimeout(() => {
        return searchDestinationsAndHotel(inputValue).then((response) => {
          if ("data" in response) resolve(response.data.results)
          else resolve(initialSearchResults)
        })
      }, 400)
    })
  }

  const __handleOnChange = (opt, action) => {
    if(action.action == "clear") {
      searchByHandler({ id: null, type: null, label: null, country: null })
    } else {
      searchByHandler({ id: opt.value, type: opt.type, label: opt.label, country: opt.country_code })
    }
  }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? "rgba(142, 201, 255, 0.3)"
        : state.isSelected
        ? "#266095"
        : null,
    }),
  }

  const groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  }

  const groupBadgeStyles = {
    backgroundColor: "#EBECF0",
    borderRadius: "2em",
    color: "#172B4D",
    display: "inline-block",
    fontSize: 12,
    fontWeight: "normal",
    lineHeight: "1",
    minWidth: 1,
    padding: "0.16666666666667em 0.5em",
    textAlign: "center",
  }

  const formatGroupLabel = (data) => (
    <div style={groupStyles}>
      <span>{data.label}</span>
      <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
  )

  // eslint-disable-next-line
  const formatOptionLabel = ({ value, label, preferred }) => (
    <div style={{ display: "flex" }} className="search-destination-label">
      <div>{label}</div>
      {preferred && (
        <div className="preferred" style={{ marginLeft: "auto" }}>
          <i className="fas fa-star" />
        </div>
      )}
    </div>
  )

  return (
    <label className="destination">
      <i className="fas fa-globe-americas main-icon" />
      <AsyncSelect
        loadOptions={promiseOptions}
        defaultOptions
        formatGroupLabel={formatGroupLabel}
        classNamePrefix="search-destination"
        className="search-destination"
        placeholder="Type city or hotel name"
        styles={customStyles}
        blurInputOnSelect
        closeMenuOnScroll
        escapeClearsValue
        isClearable
        formatOptionLabel={formatOptionLabel}
        onChange={__handleOnChange}
      />
    </label>
  )
}

SearchDestination.propTypes = {
  searchByHandler: PropTypes.func.isRequired
}

export default SearchDestination
